module.exports = __webpack_public_path__ + "img/platform_ban.png";